import type { ObjectId } from '@freightview/object-id'

import {
  vArray,
  vISODateTime,
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
  vPicklist,
  vPipe,
  vString,
} from '../validation/index.ts'
import { type UserType, userTypes } from './user.ts'

export const systemNotificationTypes = [
  'warning',
  'holiday',
  'release',
  'info',
  'default',
  'success',
  'environment',
] as const

export type SystemNotificationType = (typeof systemNotificationTypes)[number]

export interface SystemNotification {
  _id: ObjectId
  expiration: Date
  type: SystemNotificationType
  text: string
  carrierId?: ObjectId
  userType?: UserType[]
}

export type SystemGeneratedNotification = Omit<SystemNotification, '_id'> & {
  _id: string
}

export const upsertSystemNotificationSchema = vObject({
  text: vString(),
  expiration: vPipe(vString(), vISODateTime()),
  type: vPicklist(systemNotificationTypes),
  carrierId: vOptional(vObjectId()),
  userType: vOptional(vArray(vPicklist(userTypes))),
})
export type UpsertSystemNotificationDTO = vOutput<
  typeof upsertSystemNotificationSchema
>
